import { FC } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ProviderType } from "@/services/cloudchipr.api";
import { getCommitmentsResourceUrl } from "@/components/pages/commtiments/overview/content/utils/helpers/getCommitmentsResourceUrl";
import { useAppSelector } from "@/store/hooks";
import { commitmentsDatesSelector } from "@/store/commitments/selectors/common/view-options/commitmentsDatesSelector";

interface CommitmentsOverviewCoverageTableViewUtilizationLinkProps {
  name: string;
}

export const CommitmentsOverviewCoverageTableViewUtilizationLink: FC<
  CommitmentsOverviewCoverageTableViewUtilizationLinkProps
> = ({ name }) => {
  const dates = useAppSelector(commitmentsDatesSelector);

  const params = useParams();
  const provider = params?.provider as ProviderType;
  const orgId = params?.orgId ?? "";

  const isReservedInstancesResourceType = name.endsWith("RIs");
  const utilizationUrlActiveTab = isReservedInstancesResourceType
    ? "reservation"
    : "savings_plan";
  const searchValue = name.replace(/(SPs|RIs)$/, "");
  const viewUtilizationUrl = getCommitmentsResourceUrl(
    provider,
    orgId,
    utilizationUrlActiveTab,
    "commitment",
    searchValue,
    dates,
  );

  return (
    <Tooltip title="View Utilization" placement="right">
      <IconButton
        component={RouterLink}
        to={viewUtilizationUrl}
        target="_blank"
        size="small"
        sx={{ p: 0, "&:hover": { bgcolor: "transparent" } }}
      >
        <OpenInNewIcon fontSize="small" color="action" />
      </IconButton>
    </Tooltip>
  );
};
